/**
 * Items Destacados TEN - Script
 * Maneja la funcionalidad de modals
 */

class ItemsDestacadosTEN {
  constructor() {
    this.modals = document.querySelectorAll('.items-destacados-ten__modal');
    this.init();
  }

  init() {
    this.setupModalTriggers();
    this.setupKeyboardNavigation();
  }

  setupModalTriggers() {
    // Abrir modals
    document.querySelectorAll('[data-modal-trigger]').forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal-trigger');
        this.openModal(modalId);
      });
    });

    // Cerrar modals
    document.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal(closeBtn.closest('.items-destacados-ten__modal'));
      });
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';

    // Focus en el modal para accesibilidad
    setTimeout(() => {
      const closeButton = modal.querySelector('.items-destacados-ten__modal-close');
      if (closeButton) closeButton.focus();
    }, 100);

    // Trap focus dentro del modal
    this.trapFocus(modal);
  }

  closeModal(modal) {
    if (!modal) return;

    modal.style.display = 'none';
    document.body.style.overflow = '';

    // Restaurar focus al trigger que abrió el modal
    const modalId = modal.getAttribute('id');
    const trigger = document.querySelector(`[data-modal-trigger="${modalId}"]`);
    if (trigger) trigger.focus();
  }

  setupKeyboardNavigation() {
    document.addEventListener('keydown', (e) => {
      // Cerrar modal con ESC
      if (e.key === 'Escape') {
        const openModal = Array.from(this.modals).find(modal => {
          return window.getComputedStyle(modal).display !== 'none';
        });
        if (openModal) {
          this.closeModal(openModal);
        }
      }
    });
  }

  trapFocus(modal) {
    const focusableElements = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    const handleTabKey = (e) => {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    };

    modal.addEventListener('keydown', handleTabKey);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ItemsDestacadosTEN();
  });
} else {
  new ItemsDestacadosTEN();
}

// Reinicializar cuando Shopify recarga la sección en el editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    new ItemsDestacadosTEN();
  });
}
